import { countries } from "../../constants";
import {
  BMDropdownField,
  BMDropdownFieldSingleProps,
  BMDropdownOptionsValue,
} from "../BMDropdownField";

const COUNTRY_LIST: BMDropdownOptionsValue[] = countries.map((info) => {
  return {
    label: `${info.countryName} (${info.countryId})`,
    value: info.countryId,
  };
});

export type BMNationalityFieldProps = Omit<
  BMDropdownFieldSingleProps<string>,
  "option" | "variant" | "searchable"
>;

export default function BMNationalityField(props: BMNationalityFieldProps) {
  return (
    <BMDropdownField
      {...props}
      variant="RADIO"
      option={{ items: COUNTRY_LIST }}
      searchable={{
        placeholder: "Search for a country",
      }}
    />
  );
}
